module.exports = __webpack_public_path__ + "assets/img/OldPlayer.15cf61cf.png";